/* ================================================================
   SINGLE SOURCE OF TRUTH
   ----------------------------------------------------------------
   Each object below = one product. When we move to Shopify/Liquid,
   each of these maps 1:1 to a Shopify product:
     name  -> product.title
     price -> product.price
     img   -> product.featured_image
     id    -> product variant id  (added at Shopify-conversion time)
   The Buy button (see buyNow() at the bottom) is the ONLY checkout
   hook — swap its body for Shopify's cart/checkout call later.
   ================================================================ */
const _recipesEl = document.getElementById('recipes-data');
const RECIPES = _recipesEl ? JSON.parse(_recipesEl.textContent) : [];
RECIPES.push({ builder:true, bundle:true, price:20, pick:4 });

/* ---- scribble SVG (faux handwriting under the photo) ---- */
function scribbles(){
  // a few wavy lines of varying length to *imply* recipe text without showing it
  const line = (y,w)=>`<path d="M4 ${y} q40 -5 80 0 t80 0 t80 0 t80 0"
      stroke="#c9a18a" stroke-width="2.4" fill="none" stroke-linecap="round"
      stroke-dasharray="${w}" opacity=".7"/>`;
  return `
    <div class="scribbles">
      <div class="lead">the secret's inside ✦</div>
      <svg viewBox="0 0 340 78" preserveAspectRatio="none">
        ${line(10,330)}${line(28,300)}${line(46,330)}${line(64,180)}
      </svg>
    </div>`;
}

/* ---- render the two pages for a given recipe index ---- */
function leftHTML(r){
  if(r.builder) return builderLeftHTML();
  const photo = r.img
    ? `<img src="${r.img}" alt="${r.name}" onerror="this.parentElement.innerHTML='&lt;div class=ph&gt;&lt;span&gt;🍰&lt;/span&gt;photo coming soon&lt;/div&gt;'">`
    : `<div class="ph"><span>🍰</span>photo coming soon</div>`;
  return `<div class="paper-pad">
            <div class="recipe-photo">${photo}</div>
            ${scribbles()}
            <span class="folio folio--left">${RECIPES.indexOf(r)*2+2}</span>
          </div>`;
}
function rightHTML(r){
  if(r.builder) return builderRightHTML();
  const unit = r.bundle ? "bundle" : "PDF recipe";
  return `<div class="paper-pad buy-pad">
            <div class="kicker">${r.kicker}</div>
            <h3>${r.name}</h3>
            <div class="blurb">${r.blurb}</div>
            <div class="tags">${r.tags.map(t=>`<span class="tag">${t}</span>`).join("")}</div>
            <div class="price-row">
              <span class="price">$${r.price}</span>
              <small>/ ${unit}</small>
            </div>
            <button class="btn btn--gold buy-btn"
                    onclick="buyNow(${RECIPES.indexOf(r)})">Add to Cart</button>
            <div class="meta">Instant download · yours to keep forever</div>
            <span class="folio folio--right">${RECIPES.indexOf(r)*2+3}</span>
          </div>`;
}

/* ================================================================
   BUILD-YOUR-OWN BUNDLE  (pick any 4 recipes for $20)
   bundleSel holds the chosen recipe indices. State persists across
   page flips. buyBundle() is the ONLY checkout hook (Shopify later).
   ================================================================ */
const PICK = 4, BUNDLE_PRICE = 20;
const bundleSel = new Set();

function toggleBundle(i){
  if(bundleSel.has(i)) bundleSel.delete(i);
  else { if(bundleSel.size >= PICK) return; bundleSel.add(i); }
  refreshBuilder();
}
function refreshBuilder(){
  if(RECIPES[idx] && RECIPES[idx].builder){
    pgLeft.innerHTML  = builderLeftHTML();
    pgRight.innerHTML = builderRightHTML();
    addRibbon(idx);   // re-rendering innerHTML wiped the ribbon; restore it
  }
}
function builderLeftHTML(){
  const full = bundleSel.size >= PICK;
  const rows = RECIPES.map((r,i)=>({r,i})).filter(o=>!o.r.builder).map(o=>{
    const sel = bundleSel.has(o.i), dis = !sel && full;
    return `<li><label class="check ${sel?'is-checked':''} ${dis?'is-disabled':''}">
        <input type="checkbox" ${sel?'checked':''} ${dis?'disabled':''} onchange="toggleBundle(${o.i})">
        <span class="cbox" aria-hidden="true"></span>
        <span class="cname">${o.r.name}</span>
        <span class="cprice">$${o.r.price}</span>
      </label></li>`;
  }).join('');
  return `<div class="paper-pad builder-left">
            <div class="kicker">mix &amp; match</div>
            <h3 class="builder-title">Build Your Own Box</h3>
            <p class="blurb">Pick any <strong>4</strong> recipes to bundle &amp; save.</p>
            <ul class="checklist">${rows}</ul>
            <span class="folio folio--left">16</span>
          </div>`;
}
function builderRightHTML(){
  const chosen = [...bundleSel].map(i=>RECIPES[i].name);
  const ready = bundleSel.size === PICK;
  const remaining = PICK - bundleSel.size;
  const chosenList = chosen.length
    ? `<ol class="chosen-list">${chosen.map(n=>`<li>${n}</li>`).join('')}</ol>`
    : `<p class="chosen-empty">Nothing picked yet — choose 4 from the list.</p>`;
  return `<div class="paper-pad buy-pad builder-right">
            <div class="kicker">your bundle</div>
            <h3>Any 4 for $20</h3>
            <div class="blurb">Mix &amp; match your four favorite recipes and save $4.</div>
            <div class="bundle-count">${bundleSel.size} <span>of 4 chosen</span></div>
            ${chosenList}
            <div class="price-row"><span class="price">$${BUNDLE_PRICE}</span><small>/ 4 recipes</small></div>
            <button class="btn btn--gold buy-btn" ${ready?'':'disabled'} onclick="buyBundle()">
              ${ready ? 'Add Bundle to Cart' : (remaining===PICK ? 'Pick 4 recipes' : 'Pick '+remaining+' more')}</button>
            <div class="meta">Instant download · yours to keep forever</div>
            <span class="folio folio--right">17</span>
          </div>`;
}
function buyBundle(){
  if(bundleSel.size !== PICK) return;
  const items = [...bundleSel].map(function(i){ return { id:RECIPES[i].variantId, quantity:1 }; });
  if(items.some(function(x){ return !x.id; })){ alert("One of these recipes isn't available yet."); return; }
  fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'}, body: JSON.stringify({ items:items }) })
    .then(function(res){ if(!res.ok) throw new Error(); return res.json(); })
    .then(function(){ window.location.href = '/cart'; })
    .catch(function(){ alert('Sorry — could not build your bundle. Please try again.'); });
}

/* ================================================================
   FLIPBOOK ENGINE
   ================================================================ */
const book   = document.getElementById('book');
const pgLeft = document.getElementById('pgLeft');
const pgRight= document.getElementById('pgRight');
const dotsEl = document.getElementById('dots');
const prevBtn= document.getElementById('prevBtn');
const nextBtn= document.getElementById('nextBtn');
let idx = 0, animating = false;
const isMobile = ()=>window.matchMedia('(max-width:760px)').matches;

function addRibbon(i){
  book.querySelectorAll('.ribbon').forEach(n=>n.remove());
  if(RECIPES[i].bundle){
    const rib=document.createElement('div');rib.className='ribbon';
    rib.textContent=RECIPES[i].builder?'Save $4':'Best Value';
    book.querySelector('.book__page--right').appendChild(rib);
  }
}
function paint(i){
  pgLeft.innerHTML  = leftHTML(RECIPES[i]);
  pgRight.innerHTML = rightHTML(RECIPES[i]);
  pgRight.parentElement; // (right page keeps bundle class handling below)
  book.querySelector('.book__page--right').classList.toggle('book__page--bundle', !!RECIPES[i].bundle);
  addRibbon(i);
  updateDots(i);
  prevBtn.disabled = i===0;
  nextBtn.disabled = i===RECIPES.length-1;
  const bt=document.getElementById('bundleTab');
  if(bt) bt.classList.toggle('is-here', !!RECIPES[i].builder);
}

/* Show dots for small collections; switch to a compact "x / y" counter
   once there are too many to fit nicely. The Table of Contents handles
   jumping by name at any scale. */
const DOTS_MAX = 10;
function updateDots(i){
  if(RECIPES.length <= DOTS_MAX){
    dotsEl.className = 'page-dots';
    dotsEl.innerHTML = RECIPES.map((_,k)=>`<span class="dot ${k===i?'active':''}" data-i="${k}"></span>`).join('');
  } else {
    dotsEl.className = 'page-count';
    dotsEl.innerHTML = `<span>${i+1}</span> / ${RECIPES.length}`;
  }
}

/* ---- single page-turn animation to ANY target page (handles multi-page jumps) ---- */
function goTo(target){
  if(animating) return;
  if(target<0 || target>=RECIPES.length || target===idx) return;
  const dir = target>idx ? 1 : -1;
  animating = true;

  if(isMobile()){           // mobile: simple fade swap
    book.classList.add('fading');
    setTimeout(()=>{ idx=target; paint(idx); book.classList.remove('fading'); animating=false; },260);
    return;
  }

  const leaf = document.createElement('div');
  leaf.className = 'leaf ' + (dir>0 ? 'leaf--next' : 'leaf--prev');

  if(dir>0){
    // turning the RIGHT page over; reveal the target spread underneath
    leaf.innerHTML =
      `<div class="leaf__face leaf__face--front">${rightHTML(RECIPES[idx])}</div>
       <div class="leaf__face leaf__face--back">${leftHTML(RECIPES[target])}</div>`;
    book.appendChild(leaf);
    pgRight.innerHTML = rightHTML(RECIPES[target]);
  } else {
    // turning the LEFT page back; reveal the target spread underneath
    leaf.innerHTML =
      `<div class="leaf__face leaf__face--front">${leftHTML(RECIPES[idx])}</div>
       <div class="leaf__face leaf__face--back">${rightHTML(RECIPES[target])}</div>`;
    book.appendChild(leaf);
    pgLeft.innerHTML = leftHTML(RECIPES[target]);
  }
  requestAnimationFrame(()=>requestAnimationFrame(()=>leaf.classList.add('turn')));
  leaf.addEventListener('transitionend',()=>{ idx=target; paint(idx); leaf.remove(); animating=false; },{once:true});
}
function flip(dir){ goTo(idx + dir); }

if(book){
  nextBtn.addEventListener('click',()=>flip(1));
  prevBtn.addEventListener('click',()=>flip(-1));
  dotsEl.addEventListener('click',e=>{
    const d=e.target.closest('.dot'); if(!d) return;
    goTo(+d.dataset.i);   // jump straight to the clicked page
  });
}
document.addEventListener('keydown',e=>{
  if(e.key==='ArrowRight')flip(1);
  if(e.key==='ArrowLeft')flip(-1);
});

/* ---- Table of Contents: jump to any recipe by name (scales to any count) ---- */
const tocBtn=document.getElementById('tocBtn');
const tocPanel=document.getElementById('tocPanel');
function buildTOC(){
  tocPanel.innerHTML = RECIPES.map((r,k)=>{
    const label = r.builder ? 'Build Your Own Box' : r.name;
    const price = r.builder ? ('$'+r.price+' / 4') : ('$'+r.price);
    return `<button class="toc-item ${k===idx?'is-current':''}" type="button" data-i="${k}">
        <span class="toc-name">${label}</span><span class="toc-price">${price}</span></button>`;
  }).join('');
}
function toggleTOC(force){
  if(!tocPanel) return;
  const open = (force!==undefined) ? force : tocPanel.hasAttribute('hidden');
  if(open){ buildTOC(); tocPanel.removeAttribute('hidden'); tocBtn.setAttribute('aria-expanded','true'); }
  else { tocPanel.setAttribute('hidden',''); tocBtn.setAttribute('aria-expanded','false'); }
}
if(tocBtn){
  tocBtn.addEventListener('click',e=>{ e.stopPropagation(); toggleTOC(); });
  tocPanel.addEventListener('click',e=>{
    const it=e.target.closest('.toc-item'); if(!it) return;
    toggleTOC(false);
    goTo(+it.dataset.i);
  });
  document.addEventListener('click',e=>{
    if(!tocPanel.contains(e.target) && e.target!==tocBtn) toggleTOC(false);
  });
}
document.addEventListener('keydown',e=>{ if(e.key==='Escape') toggleTOC(false); });

/* ================================================================
   CHECKOUT HOOK  —  the ONLY thing that changes for Shopify.
   Right now it's a placeholder. In the Liquid version this becomes
   an add-to-cart / direct-checkout call against the Shopify product.
   ================================================================ */
function buyNow(i){
  const r = RECIPES[i];
  if(!r.variantId){ alert("This recipe isn't available yet — check back soon!"); return; }
  addToCart(r.variantId, 1);
}
function addToCart(id, qty){
  fetch('/cart/add.js', { method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ items:[{ id:id, quantity:qty }] }) })
    .then(function(res){ if(!res.ok) throw new Error(); return res.json(); })
    .then(function(){ refreshCartCount(); showCartToast(); })
    .catch(function(){ alert('Sorry — could not add to cart. Please try again.'); });
}
function refreshCartCount(){
  fetch('/cart.js').then(function(r){ return r.json(); }).then(function(c){
    var el = document.getElementById('cartCount');
    if(el){ el.textContent = c.item_count; el.closest('.cart-link').classList.toggle('has-items', c.item_count>0); }
  }).catch(function(){});
}
var _cartToastT;
function showCartToast(){
  var t = document.getElementById('cartToast');
  if(!t){ t = document.createElement('div'); t.id='cartToast'; t.className='cart-toast'; document.body.appendChild(t); }
  t.innerHTML = '✓ Added to cart — <a href="/cart">View cart</a>';
  t.classList.add('show');
  clearTimeout(_cartToastT); _cartToastT = setTimeout(function(){ t.classList.remove('show'); }, 3500);
}

if(book){ paint(0); }
refreshCartCount();

/* remove an item from the cart (works on the cart page) */
document.addEventListener('click', function(e){
  var rm = e.target.closest('.cart-remove'); if(!rm) return;
  e.preventDefault();
  fetch('/cart/change.js', { method:'POST', headers:{'Content-Type':'application/json'},
    body: JSON.stringify({ line: parseInt(rm.dataset.line,10), quantity: 0 }) })
    .then(function(){ window.location.reload(); })
    .catch(function(){ window.location.reload(); });
});

/* bundle quick-jump tab → jump straight to the build-your-own page */
var _bundleTab = document.getElementById('bundleTab');
if(_bundleTab){
  _bundleTab.addEventListener('click',function(){
    const last=RECIPES.length-1;
    if(idx!==last){ idx=last; paint(last); }
    book.scrollIntoView({behavior:'smooth', block:'center'});
  });
}

/* subtle shadow under the sticky nav once you scroll off the top */
var _hdr=document.querySelector('header.site');
window.addEventListener('scroll',function(){
  _hdr.classList.toggle('scrolled', window.scrollY>20);
},{passive:true});
